import CustomDateRange from "components/Atoms/CustomDateRange"
import StaticSelector from "components/Atoms/StaticSelector"
import DynamicSelector from "components/Molecules/DynamicSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import { VARIETIES } from "graphql/selector.queries.gql"
import React from "react"
import { useDispatch } from "react-redux"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { RESET_SELECTED } from "store/selector.redux"
const UploaderFilter = () => {
  const [filter, setFilter] = useFilter("production-batch-uploader")
  const dispatch = useDispatch()

  function resetSelected() {
    dispatch({
      type: RESET_SELECTED,
      path: "production-batch-uploader",
    })
  }
  return (
    <SearchFilter
      onClear={() => {
        setFilter({})
        resetSelected()
      }}
      value={filter ?? {}}
      getValues={value => {
        setFilter(value)
        resetSelected()
      }}
      className="ml-3"
    >
      <SearchFilterCallout title="Created On">
        <CustomDateRange
          path="dateRange"
          className="mb-1 mt-2"
          inline
          big={false}
        />{" "}
      </SearchFilterCallout>

      <SearchFilterCallout title="Variety" fill>
        <DynamicSelector
          fill
          big
          formClassName="col-span-2"
          query={VARIETIES}
          variables={{
            includeCommodity: false,
          }}
          path="variety"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Is Active" fill>
        <StaticSelector
          fill
          big
          formClassName="col-span-2"
          items={[
            {
              id: "yes",
              name: "Yes",
            },
            { id: "no", name: "No" },
          ]}
          path="active"
        />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default UploaderFilter
